import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
export const GET_FOLDERS_HIERARCHY_FIELD_NAME = 'fetchFolderHierarchy';
export const GET_FOLDER_HIERARCHY = registerQuery({
  args: ['folderId'],
  fieldName: GET_FOLDERS_HIERARCHY_FIELD_NAME,
  fetcher({
    folderId
  }) {
    return http.get(`framework/folders/v1/path/${folderId}`);
  }
});
/**
 * Fetches all direct folders in the hierarchy from @currentFolderId up until the top-level folder (where parentFolderId is -1).
 * The endpoint we use **does not** return sibling folders in the hierarchy and we need to make an extra API call to CRM search later for us to properly rebuild the folder tree navigation.
 *
 * The optional @skip prop is necessary so we only load this hierarchy when rendering the UI for the first time inside of a folder.
 *
 * @returns a flat list of CrmObjects (folders). Element at 0 is the top-level folder, element at length - 1 is the folder that matches currentFolderId.
 */
export default function useFetchFolderPath({
  currentFolderId,
  skip
}) {
  const {
    data,
    loading
  } = useQuery(GET_FOLDER_HIERARCHY, {
    variables: {
      folderId: currentFolderId
    },
    skip
  });
  const value = useMemo(() => {
    return {
      loading,
      folders: data && GET_FOLDERS_HIERARCHY_FIELD_NAME in data ? data.fetchFolderHierarchy : []
    };
  }, [data, loading]);
  return value;
}